import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { removeEmergentBranding } from "@/lib/removeEmergentBranding";
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Metrics from '@/components/Metrics';
import Features from '@/components/Features';
import Testimonials from '@/components/Testimonials';
import Partnership from '@/components/Partnership';
import FAQ from '@/components/FAQ';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import AdminPanel from '@/pages/AdminPanel';
import FinanceEntry from '@/pages/FinanceEntry';
import OccupancyManagement from '@/pages/OccupancyManagement';
import RoomManagement from '@/pages/RoomManagement';
import TenantDashboard from '@/pages/TenantDashboard';
import TenantLogin from '@/pages/TenantLogin';
import TenantRegister from '@/pages/TenantRegister';
import PropertyDetail from '@/pages/PropertyDetail';

const PAGE_TITLES = {
  '/': 'ISK | Property Management',
  '/login': 'Login | ISK',
  '/tenant/login': 'Login Tenant | ISK',
  '/dashboard': 'Dashboard Owner | ISK',
  '/admin': 'Admin | ISK',
  '/tenant/dashboard': 'Dashboard Tenant | ISK',
};

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const matchedRoute = Object.keys(PAGE_TITLES)
      .sort((a, b) => b.length - a.length)
      .find((route) => pathname === route || pathname.startsWith(`${route}/`));

    document.title = matchedRoute ? PAGE_TITLES[matchedRoute] : 'ISK | Property Management';
    removeEmergentBranding();
  }, [pathname]);

  return null;
};

const HomePage = () => {
  return (
    <div className="bg-isk-bg">
      <Header />
      <Hero />
      <Metrics />
      <Features />
      <Testimonials />
      <Partnership />
      <FAQ />
      <ContactForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTitle />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/properties/:propertyName" element={<PropertyDetail />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/finance/:propertyName/:ownerEmail" element={<FinanceEntry />} />
          <Route path="/admin/occupancy/:propertyName/:ownerEmail" element={<OccupancyManagement />} />
          <Route path="/admin/rooms/:propertyName/:ownerEmail" element={<RoomManagement />} />
          <Route path="/tenant/login" element={<TenantLogin />} />
          <Route path="/tenant/dashboard" element={<TenantDashboard />} />
          <Route path="/daftar" element={<TenantRegister />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
